import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { RADOM_COLORS } from '../util/Constants'

const Container = styled.div`
  font-size: 12px;
  line-height: 20px;
`

const Steps = styled.ul`
  background-color: ${RADOM_COLORS.GRAY_DARK};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 15px;
  list-style-type: none;
  padding: 0;
  border-radius: 20px;
  margin: 0;
  width: 4px;
  position: sticky;
  top: 100px;
  user-select: none;
`

const Step = styled.li<{ index: number, active: boolean, completed: boolean, clickable: boolean, hasError: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 20px;
  position: relative;
  text-align: center;

  ${({ index, active, completed, clickable, hasError }) => `
      cursor: ${clickable ? 'pointer' : 'default'};

      &:before {
          content: '${hasError ? '!' : index}';
          border-radius: 50%;
background-color: ${
  active
    ? RADOM_COLORS.BLUE4
    : hasError
      ? RADOM_COLORS.ERROR
      : completed
        ? RADOM_COLORS.SUCCESS
        : RADOM_COLORS.GRAY4
};
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 22px;
          min-width: 22px;
          transition: 0.2s ease all;
      }

      span {
          color: ${
  active
    ? RADOM_COLORS.BLUE4
    : hasError
      ? RADOM_COLORS.ERROR
      : completed
        ? RADOM_COLORS.SUCCESS
        : RADOM_COLORS.GRAY4
};
          position: absolute;
          left: 24px;
          white-space: nowrap;
          ${active ? 'font-weight: bold;' : ''}
      }`}
`

interface IProps {
  steps: Array<{ id: string, label: string }>
  currentStep: string
  completedSteps: string[]
  canNavigateToStep: (stepId: string) => boolean
  onStepClick: (stepId: string) => void
  errorSteps?: string[]
}

const ProgressIndicator = ({ steps, currentStep, completedSteps, canNavigateToStep, ...props }: IProps):
ReactElement => (
  <Container>
    <Steps>
      {steps.map((step, index) => (
        <Step
          hasError={props.errorSteps?.includes(step.label) ?? false}
          key={step.id}
          index={index + 1}
          active={currentStep === step.label}
          completed={completedSteps.includes(step.label)}
          clickable={canNavigateToStep(step.id)}
          onClick={() => {
            if (canNavigateToStep(step.id)) {
              props.onStepClick(step.id)
            }
          }}
        >
          <span>{step.label}</span>
        </Step>
      ))}
    </Steps>
  </Container>
)

export default ProgressIndicator
